import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import LeaderboardScore from '../../leaderboard/score/LeaderboardScore';
import AttractorTimeout from '../../warning/attractorTimeout';

const EndGameTTB = ({ config, gameData, passRefUpward }) => {
    const params = new URLSearchParams(window.location.hash);
    const score = params.get('#/endgamescore?score');
    const level = params.get('level');
    const game = params.get('game');

    const [scores, setScores] = useState([]);
    const [currentScore, setCurrentScore] = useState({});
    const [showRedirect, setShowRedirect] = useState(false);

    const storePlayData = () => {
        const playData = {
            score,
            level
        };
        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));
        sessionData.playData.push(playData);
        window.sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    };

    // const isHighScore = scores.map((score, idx) => {
    //     if (idx > 9) return false;
    //     return toLocalStorage.date === score.date;
    // }).includes(true);

    useEffect(() => {

        const toLocalStorage = {
            "score": parseInt(score, 10),
            "level": level,
            "game": game,
            "date": Date.now(),
        };

        setCurrentScore(toLocalStorage);

        const storedScores = JSON.parse(sessionStorage.getItem("storedScores") || "[]");
        toLocalStorage.score && storedScores.push(toLocalStorage);
        sessionStorage.setItem("storedScores", JSON.stringify(storedScores));
        storedScores.sort((a, b) => b.date - a.date).sort((a, b) => b.score - a.score);
        setScores(storedScores);

        storePlayData();
        // eslint-disable-next-line
    }, []);

    AttractorTimeout(config, passRefUpward);

    return (
        <div className='endGameScore'>

            {showRedirect &&
                <Redirect push to='/executables/track-the-ball/attractor' />
            }

            <div className='endGameScore__left'>
                {score && (
                    <p className='endGameScore__left-score'>
                        <span>{config.screens.endGameScore.you_scored}</span>
                        <span className='score'>{parseInt(score).toLocaleString()}</span>
                        {level && (
                            <span>Level {level}</span>
                        )}
                    </p>
                )}
                <div className='endGameScore__left-block'>
                    <span>
                        <img src={`img/game_icons/${gameData.screens.leaderboardScreen.icon}.svg`} alt='' />
                    </span>
                    <h1>{config.screens.endGameScore.block_title}</h1>
                    <p>{config.screens.endGameScore.block_text}</p>
                </div>
                <div className='endGameScore__left-button App__button-large-container'>
                    <button onClick={() => setShowRedirect(true)}>
                        {config.screens.endGameScore.button_text}
                    </button>
                    <span> </span> {/* Decorative span */}
                    <span> </span> {/* Decorative span */}
                </div>
            </div>
            <LeaderboardScore IsEndGameScore scores={scores} currentScore={currentScore} config={config} />
        </div>
    );
};

export default EndGameTTB;
